import Cookies from "js-cookie";
import { useEffect } from "react";
import useAuth from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { getUseRoute } from "@/utils/userroutes/loginroutes2";

const IndexPage = () => {
  const navigate = useNavigate();
  const { profile } = useAuth();

  useEffect(() => {
    if (!profile) return;
    const nextUrl = getUseRoute(profile?.roles?.[0]?.roleName);
    if (Cookies.get("token")) {
      navigate(nextUrl);
    } else {
      navigate("/HomePage");
    }
  }, [navigate, profile]);
  return null;
};

export default IndexPage;
